import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-word-to-png',
    imports: [],
    templateUrl: './blog-word-to-png.component.html',
    styleUrl: './blog-word-to-png.component.css'
})
export class BlogWordToPngComponent {

}
